// EventBus(数据总线)
import Vue from 'vue'
export default new Vue()
